<template>
    <div class="footer-container">
        <div class="footer-content">
            <div class="aiqicha">
                <div class="title">爱企查</div>
                <p v-for="(item, index) in aiqicha" :key="index">
                <a :href="item.link" target="_blank"
                    :data-track-value="'landFooteraiqicha' + item.value"
                    :data-track-name="'落地页底部爱企查' + item.text">{{item.text}}</a>
                </p>
            </div>
            <div class="company">
                <div class="title">云企业服务中心</div>
                <p v-for="(item, index) in company" :key="index">
                {{item}}
                </p>
            </div>
            <div class="help-link">
                <div class="title">友情链接</div>
                <a v-for="(item, index) in help" :key="index" :href="item.link" target="_blank"
                :data-track-value="'landFooterHelp' + item.value"
                :data-track-name="'落地页底部友情链接' + item.text">{{item.text}}</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            aiqicha: [
                {
                text: '关于我们',
                link: 'https://aiqicha.baidu.com/fs/about',
                value: 'about'
                },
                {
                text: '用户协议',
                link: 'https://aiqicha.baidu.com/fs/protocol',
                value: 'rule'
                },
                {
                text: '免责声明',
                link: 'https://www.baidu.com/duty/',
                value: 'duty'
                }
            ],
            company: [
                '商务咨询：400-877-7898 转 66666',
                '联系邮箱：mktpartners@baidu.com'
            ],
            help: [
                {
                text: '百度云市场',
                link: ' http://market.baidu.com/',
                value: 'market'
                },
                {
                text: '百度AI市场',
                link: ' https://aim.baidu.com/',
                value: 'AI'
                },
                {
                text: '百度建站',
                link: 'http://aipage.baidu.com/',
                value: 'network'
                },
                {
                text: '百度统计',
                link: 'https://tongji.baidu.com/web/welcome/',
                value: 'tongji'
                },
                {
                text: '域名注册',
                link: 'https://cloud.baidu.com/product/bcd.html',
                value: 'bcd'
                },
                {
                text: '开发者中心',
                link: 'https://developer.baidu.com/',
                value: 'develop'
                }
            ]
        }
    }
}
</script>

<style lang="less" scoped>
.footer-container {
    height: 202px;
    background: #141924;
    padding-top: 32px;
    .footer-content {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    .title {
        height: 22px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 22px;
        color: #fff;
        margin-bottom: 24px;
    }
    p {
        margin-top: 16px;
        height: 20px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: #fff;
        opacity: 0.5;
    }
    a {
        text-decoration: none;
        color: #fff;
    }
    a:visited {
        color: #fff;
    }
    .help-link {
        width: 334px;
        a {
        display: inline-block;
        height: 20px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: #fff;
        opacity: 0.5;
        margin-right: 20px;
        margin-bottom: 16px;
        }
    }
}
</style>
